import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "my-field",
    templateUrl: "./field.component.html",
    styleUrls: ["./field.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule],
})
export class FieldComponent{
    @Input() type = "text";
    @Input() value: string;
    @Output() valueChange = new EventEmitter<string>();
    @Input() placeholder?: string;
    @Input() label: string;
    @Input() disabled?: boolean;
    @Input() maxlength?: number;
    @Input() asSelect?: boolean;
    @Input() selectOptions?: ({key: string, value?: string}|string)[];

    public id = `${Date.now()}-field-${window.crypto.getRandomValues(new Uint16Array(1)).toString()}`;

    public get options(): {key: string, value: string}[] {
        return this.selectOptions.map(p => {
            if (typeof(p) === 'string') {
                return {key: p, value: p};
            }
            return {key: p.key, value: p.value ?? p.key};
        });
    }

    public onValueChange() {
        this.valueChange.emit(this.value);
    }
}
